import styles from '../../../pages/Badging/AdminPrint/AdminPrint.module.css'

const PaidAfterDate = ({ formData, handleChange, onBlur, regError }) => {

    return (
        <div className={styles.dropdownContainer}>
            <input
                className={styles.datePicker}
                type="date"
                value={formData.paidAfterDate ? formData.paidAfterDate.split('T')[0] : ''}
                onChange={handleChange} // option selected
                name="paidAfterDate"
                onBlur={onBlur}
            />
            {regError && regError.length > 0 ?
                <div style={{ color: 'red' }}>
                    <br />
                    Error: {regError}
                </div>

                : <></>
            }
        </div>
    );
}

export default PaidAfterDate;